import { NextRouter } from 'next/router'

// For any particular router.query entry, we can technically receive multiple values, but for path
// segments in particular we should only ever receive one (to receive two, you’d have to access
// something like /products/lol?permalink=lol). And then when people click from emails, we often
// receive those URL-encoded which causes a mess because Next.js doesn’t parse those out.
export const getQueryValue = (value: string | string[]) => {
  const singularValue = Array.isArray(value) ? value[0] : value

  if (singularValue) {
    return decodeURIComponent(singularValue).split('?')[0]
  }

  return undefined
}

export const removeQueryParam = (router: NextRouter, paramToRemove: string) => {
  // Get the current query parameters
  const queryParams = { ...router.query }

  // Check if the specified param exists
  if (paramToRemove in queryParams) {
    // Remove the specified param
    delete queryParams[paramToRemove]

    // Update the URL with the remaining query params, without reloading the page
    router.replace(
      {
        pathname: router.pathname,
        query: queryParams,
      },
      undefined,
      { shallow: true },
    )
  }
}
